import { render, staticRenderFns } from "./addPatient.vue?vue&type=template&id=05411006&scoped=true"
import script from "./addPatient.vue?vue&type=script&lang=js"
export * from "./addPatient.vue?vue&type=script&lang=js"
import style0 from "./addPatient.vue?vue&type=style&index=0&id=05411006&prod&scoped=true&lang=css"
import style1 from "./addPatient.vue?vue&type=style&index=1&id=05411006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05411006",
  null
  
)

export default component.exports